// Phase 18 · Community · Category sidebar (14 hardcoded)
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Hash, TrendingUp, Home } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function CategorySidebar({ activeSlug }) {
    const [cats, setCats] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const r = await fetch(`${API}/api/community/categories`, { credentials: "include" });
                if (r.ok) {
                    const d = await r.json();
                    setCats(d.items || []);
                }
            } catch {}
            setLoading(false);
        })();
    }, []);

    return (
        <aside
            className="w-full lg:w-64 flex-shrink-0 space-y-1"
            data-testid="community-sidebar"
        >
            <div className="pb-2 mb-2 border-b border-[#1A1A1A]">
                <p className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">
                    Navigate
                </p>
            </div>
            <Link
                to="/community"
                className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-all ${!activeSlug ? "bg-[#FFFFFF]/10 text-[#FFFFFF]" : "text-neutral-300 hover:bg-white/5"}`}
                data-testid="sidebar-nav-feed"
            >
                <Home size={16} />
                All Posts
            </Link>
            <Link
                to="/community?sort=top"
                className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-neutral-300 hover:bg-white/5 transition-all"
                data-testid="sidebar-nav-trending"
            >
                <TrendingUp size={16} />
                Trending
            </Link>

            <div className="pt-4 pb-2 mb-2 border-b border-[#1A1A1A]">
                <p className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">
                    Categories
                </p>
            </div>
            {loading && <p className="text-xs text-neutral-500 px-3">Loading…</p>}
            {cats.map((c) => (
                <Link
                    key={c.slug}
                    to={`/community/${c.slug}`}
                    className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-all ${activeSlug === c.slug ? "bg-[#FFFFFF]/10 text-[#FFFFFF] font-medium" : "text-neutral-300 hover:bg-white/5"}`}
                    data-testid={`sidebar-cat-${c.slug}`}
                    title={c.description}
                >
                    <Hash size={14} className="text-neutral-500" />
                    {c.name}
                </Link>
            ))}
        </aside>
    );
}
